// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsCancer = {
  benefits_section_cancer: {
    contentful_name: '[DEFAULT] Benefits Section - Cancer ',
    header_covered_services: '承保服务',
    covered_services_text: '以下是您的计划涵盖的部分服务。完整列表请查看您的计划文档。',
    header_coverage_levels: '保障级别',
    coverage_level_text: '您可以在注册时选择您偏好的金额。',
    header_additional_text: '附加福利',
    additional_text: '您可以选择购买以下附加保障:',
    header_limitations: '限制',
    header_recurrence_coverage: '复发保障',
    recurrence_coverage_text: '如果您的癌症复发,本计划将提供以下保障:',
    header_additional_information: '附加信息',
    header_waiting_period: '等待期',
    waiting_period: '该计划在保障生效前设有等待期。如果您在等待期结束前被确诊,将无法获得赔付。',
    header_preventive_services: '预防性服务',
    preventive_services: '该计划为以下预防性检查和筛查提供保障:',
    deductible_tooltip: '您的保费可能取决于您的年龄,并且您可能需要接受健康检查以确定承保范围。',
    kids_display_text: '孩子可能被覆盖至{x}岁',
    header_initial_diagnosis_benefits: '初次确诊保障金',
    initial_diagnosis_benefits: '当您首次被诊断患有承保范围内的癌症时所获得的赔付。',
    recurrence_coverage_text2: '如果您罹患另一种癌症,该计划将正常赔付。',
    limitations_description:
      '癌症保险不会为您在投保前已确诊的任何癌症提供赔付。保险福利也不适用于您在治疗期间出现的任何癌症相关疾病,例如肺炎或感染。',
    display_name: '癌症',
  },
};
